import { MenuItem } from "@material-ui/core";
import pluralize from "pluralize";
import React from "react";
import { MAX_WINDOW_SIZE_IN_DAYS, MIN_WINDOW_SIZE_IN_DAYS } from "../consts";
import SetupLinkSelect from "../SetupLinkSelect";

const dayOptions = [...Array<number>(MAX_WINDOW_SIZE_IN_DAYS - MIN_WINDOW_SIZE_IN_DAYS + 1)].map(
  (_, index) => index + MIN_WINDOW_SIZE_IN_DAYS,
);

export type DaysWindowPickerProps = {
  value: number;
  onChange: (days: number) => void;
};

const DaysWindowPicker = ({ value, onChange }: DaysWindowPickerProps) => {
  const handleChange = (event: React.ChangeEvent<{ value: number }>) => {
    onChange(event.target.value);
  };

  return (
    <SetupLinkSelect cw-id="link-window-size-days" value={value} onChange={handleChange}>
      {dayOptions.map((day) => (
        <MenuItem key={day} value={day}>
          {day} {pluralize("day", day)}
        </MenuItem>
      ))}
    </SetupLinkSelect>
  );
};

export default DaysWindowPicker;
